import React from 'react';
import type { MarketIndex } from '@/types/bot';

interface MarketTickerProps {
  indices: MarketIndex[];
}

function formatNumber(n: number): string {
  return n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
}

export const MarketTicker: React.FC<MarketTickerProps> = ({ indices }) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 0 }}>
      {indices.map((idx, i) => {
        const isUp = idx.direction === 'up';
        const trendColor = isUp ? '#10B981' : '#EF4444';
        const arrow = isUp ? '\u25B2' : '\u25BC';

        return (
          <React.Fragment key={idx.name}>
            {i > 0 && (
              <span
                style={{
                  width: 1,
                  height: 16,
                  backgroundColor: 'var(--border)',
                  margin: '0 12px',
                  flexShrink: 0,
                }}
              />
            )}
            <span style={{ display: 'inline-flex', alignItems: 'center', gap: 6 }}>
              <span
                className="market-ticker__label"
                style={{
                  color: 'var(--text-secondary)',
                  fontSize: '0.75rem',
                  fontWeight: 600,
                }}
              >
                {idx.name}
              </span>
              <span
                style={{
                  fontFamily: 'var(--font-mono)',
                  color: 'var(--text-primary)',
                  fontSize: '0.8rem',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {formatNumber(idx.value)}
              </span>
              <span
                style={{
                  fontFamily: 'var(--font-mono)',
                  color: trendColor,
                  fontSize: '0.7rem',
                  fontVariantNumeric: 'tabular-nums',
                }}
              >
                {arrow} {Math.abs(idx.changePercent).toFixed(2)}%
              </span>
            </span>
          </React.Fragment>
        );
      })}
    </div>
  );
};
